import {TableSortDirection} from '~/components/Table';

export type SortFunction<T> = (records: T[], field: string, direction: TableSortDirection) => T[];

export function sortByNumber<T>(records: T[], field: string, direction: TableSortDirection): T[] {
    return direction === TableSortDirection.ASC
        ? records.sort((a, b) => a[field] - b[field])
        : records.sort((a, b) => b[field] - a[field]);
}

export function sortByBoolean<T>(records: T[], field: string, direction: TableSortDirection): T[] {
    return direction === TableSortDirection.ASC
        ? records.sort((a, b) => (a[field] === b[field]) ? 0 : a[field] ? -1 : 1)
        : records.sort((a, b) => (a[field] === b[field]) ? 0 : b[field] ? -1 : 1);
}

export function sortByString<T>(records: T[], field: string, direction: TableSortDirection): T[] {
    return direction === TableSortDirection.ASC
        ? records.sort((a, b) => (a[field] || '').localeCompare((b[field] || '')))
        : records.sort((a, b) => (b[field] || '').localeCompare((a[field] || '')));
}

export function sortByInterval<T>(records: T[], field: string, direction: TableSortDirection): T[] {
    return direction === TableSortDirection.ASC
        ? records.sort((a, b) => (a[field]?.start ?? '').localeCompare(b[field]?.start ?? '') || (a[field]?.end ?? '').localeCompare(b[field]?.end ?? ''))
        : records.sort((a, b) => (b[field]?.start ?? '').localeCompare(a[field]?.start ?? '') || (b[field]?.end ?? '').localeCompare(a[field]?.end ?? ''));
}
